<template>
  <div class="icon-wrapper">
    <img
      loading="lazy"
      :src="require('@/assets/careers/' + svgPath + '.svg')"
      class="icon"
    />
    <h4 class="icon-title">{{ title }}</h4>
    <p class="icon-text">
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'Icon',
  props: ['svgPath', 'title', 'text'],
};
</script>

<style scoped>
.icon-wrapper {
  --icon-title-margin: 0;
  --icon-title-f-size: 14px;
  --icon-text-f-size: 14px;
  --culture-icons-gap: 0;
  --culture-icon-width: 80%;
  max-width: var(--max-width);
  justify-self: center;
  margin-bottom: 4em;
  min-width: 70%;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto 1fr;
  gap: var(--culture-icons-gap);
}
.icon {
  grid-row: 1 / -1;
  width: var(--culture-icon-width);
  justify-self: flex-start;
}
.icon-title {
  grid-column: 2;
  grid-row: 1;
  margin: var(--icon-title-margin);
  color: var(--page-text-color);
  font-size: var(--icon-title-f-size);
  font-weight: bold;
}
.icon-text {
  grid-column: 2;
  grid-row: 2;
  color: var(--page-text-color);
  font-size: var(--icon-text-f-size);
}
@media (min-width: 768px) {
  .icon-wrapper {
    display: block;
    --max-width: 220px;
    --icon-title-margin: 1em 0 0.4em 0;
    --icon-title-f-size: 18px;
    --icon-text-f-size: 16px;
    --culture-icons-gap: 1em;
    --culture-icon-width: auto;
  }
}
</style>
